import React, { useEffect } from 'react';
import Loader from 'react-simple-loading';

import Cam4Logo from '../../assets/CAM4-black-white.png';
import callApi from '../../utils/callApi';
import { CAM4_OAUTH } from '../../constants/apiUrls/apiUrls';
import '../../css/styles.css';
import '../../css/utils/flex.css';


function LoginWithCAM4(props) {
  const { user, shouldDoLogin } = props;
  const CAM4_OAUTH_REDIRECT_URI = `https://${window.location.hostname}/cam4oauth`;

  const doLogin = () => {
    callApi(CAM4_OAUTH, 'POST', {}, {}, {}, false, false, false).then((res) => {
      const { data } = res;
      const {
        clientid,
        loginUri,
        scope,
        responseType,
        state,
      } = data;

      const URL = `${loginUri}?client_id=${encodeURIComponent(clientid)}&scope=${encodeURIComponent(scope)}&redirect_uri=${encodeURIComponent(CAM4_OAUTH_REDIRECT_URI)}&response_type=${encodeURIComponent(responseType)}&state=${encodeURIComponent(state)}`;
      window.location.href = URL;
    }).catch((err) => {
      console.error(err);
    });
  };

  useEffect(() => {
    if (shouldDoLogin) {
      doLogin();
    }
  }, [shouldDoLogin]);

  if (!user?.features?.includes('LOGIN_WITH_CAM4')) {
    return null;
  }

  if (shouldDoLogin) {
    return (
      <div className="flex items-center" style={{ minHeight: '100vh' }}>
        <Loader color="white" />
      </div>
    );
  }

  return (
    <React.Fragment>
      <button className="cam4-login-btn flex items-center justify-around" onClick={doLogin} >
        <img alt="CAM4" className="cam4-login-logo" src={Cam4Logo} />
        <p>Login with CAM4</p>
      </button>
      <div className="auth-divider flex items-center">
        <span />
        <small>OR</small>
        <span />
      </div>
    </React.Fragment>
  );
}

export default LoginWithCAM4;
